import React from "react";
import CloseIcon from "ui/Icons/Close";
import Button from "ui/Button";
import { AnalyticsProps } from "utils/analytics/AnalyticsProps";

export interface CloseButtonProps extends AnalyticsProps {
  className?: string;
  onClick: () => void;
}

function CloseButton({
  analyticsName,
  analyticsSurface,
  analyticsProperties,
  className,
  onClick,
}: CloseButtonProps) {
  return (
    <Button
      variant="icon"
      analyticsName={analyticsName}
      analyticsSurface={analyticsSurface}
      analyticsProperties={analyticsProperties}
      className={className}
      onClick={onClick}
      requestInProgress={false}
    >
      <CloseIcon color="ColorSpace500" title="close" role="img" />
    </Button>
  );
}

export default CloseButton;
